/**
 * Coupon Image Utilities
 *
 * Utilities for getting coupon images.
 * Business logic is 100% identical to mobile module-flash-sale.
 *
 * @module @kidslabs/module-flash-sale/utils/coupon-image-utils
 */

import type { CouponContentResponse } from '../types/front.graphql';

/**
 * Get image URL for a coupon
 *
 * Priority order:
 * 1. coupon.image
 * 2. First partner image
 * 3. brand_image
 * 4. Empty string (fallback)
 *
 * @param coupon - Coupon content response
 * @returns Image URL string
 */
export const getCouponImageUri = (coupon: CouponContentResponse): string => {
    const { image, brand_image: brandImage, partner } = coupon;

    // Priority 1: Direct coupon image
    if (image) return image;

    // Priority 2: First partner's image
    const firstPartnerImage = partner?.[0]?.image;
    if (firstPartnerImage) return firstPartnerImage;

    // Priority 3: Brand image
    return brandImage || '';
};
